export enum CourseRunBookingStatus {
  PENDING = 0,
  PAID = 1,
  EXPIRED = 2,
  CANCELLED = 4,
}
